var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"flex items-start gap-2 text-red-400 text-sm px-2 mt-2",attrs:{"role":"alert"}},[_c('Font-awesome-icon',{staticClass:"mt-0.5 flex-none",attrs:{"icon":['fas', 'circle-exclamation'],"aria-hidden":"true"}}),_c('span',[_vm._v(_vm._s(_vm.error))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }